// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"1702":"4d34c113","7222":"18394c63","7937":"de4f6177"}[chunkId] || chunkId) + "." + {"1702":"2832d1dcac77b836","5763":"866853df18b05c06","6893":"f11af5435874fc80","6974":"f02413635b2470b6","7222":"7d245718551967ca","7937":"c6d055ce529e589a"}[chunkId] + ".js";
};